const template = `
	<div class="chosen-filters">
		<drop-panel
			ref="dropPanel"
			class="add-filter-drop-panel"
			anim="btt"
			@change="onAddFilterChange"
		>
			<div class="add-filter">
				<i class="fa fa-plus"></i>
				{{ ii('ADD_FILTER') }}
			</div>
			
			<items-list slot="box" :items="allFilters">
				<template slot="item" slot-scope="s">
					<drop-panel corner="top-right" anim="rtl">
						<span class="list-item-inner">
							<i :class="'fa fa-fw fa-' + s.item.icon"></i>
							{{ s.item.text }}
						</span>
						<div slot="box">
							<filter-item :filter-key="s.item.key" open="1"></filter-item>
						</div>
					</drop-panel>
				</template>
			</items-list>
		</drop-panel>
		
		<div v-for="item in filters" class="item">
			<drop-panel anim="btt" :ref="'filterPanel_' + item.key">
				<span class="item-text">
					<span class="item-label">{{ ii(item.label) }}:</span>
					{{ getFormattedVal(item.key) }}
				</span>
				<filter-item slot="box" :filter-key="item.key" open="1" @change="onFilterChange(item.key)"></filter-item>
			</drop-panel>
			<div class="close-btn fa fa-remove" v-title="ii('REMOVE_FILTER')" @click="remove(item)"></div>
		</div>
		
		<drop-panel
			ref="segmentsDropPanel"
			anim="btt"
			class="segments-drop-panel"
		>
			<div class="segments-btn">
				<i class="fa fa-thumbs-o-up"></i>
				{{ ii('SEGMENTS') }}
			</div>
			<items-list slot="box" :items="segmentItems">
				<template slot="item" slot-scope="s">
					<div v-if="s.item.url" class="segment-item">
						<router-link :to="s.item.url" class="list-item-inner" @click.native="onSegmentClick(s.item)">
							{{ s.item.text }}
						</router-link>
						<span class="segment-controls">
							<span
								class="zmdi zmdi-edit"
								v-title="ii('RENAME_SEGMENT')"
								@click="editSegment(s.item)"
							></span>
							<span
								class="zmdi zmdi-close"
								v-title="ii('REMOVE_SEGMENT')"
								@click="removeSegment(s.item)"
							></span>
						</span>
					</div>
					<span v-else class="list-item-inner" @click="addSegment">
						<i :class="'fa fa-fw fa-' + s.item.icon"></i>
						{{ s.item.text }}
					</span>
				</template>
			</items-list>
		</drop-panel>
	</div>
`;

export default {
	template,
	data() {
		return {
			newFilterKey: null
		};
	},
	computed: {
		ownershipItems() {
			return [
				{key: undefined, text: this.ii('OWN_DOMAINS')},
				{key: 'granted', text: this.ii('GRANTED_DOMAINS')},
				{key: 'all', text: this.ii('ALL_DOMAINS')}
			];
		},
		allFilters() {
			return Object.values(this.filtersMap).filter(f => !f.hidden).map(f => {
				return {
					key: f.key,
					icon: f.icon,
					text: this.ii(f.label)
				};
			});
		},
		filters() {
			let items = Object.keys(this.app.query)
				.map(key => this.filtersMap[key])
				.filter(it => it && this.app.query[it.key]);
			return items;
		},
		segmentItems() {
			let items = (this.app.segments || []).map(s => {
				return {
					id: s.id,
					text: s.name,
					url: '?' + s.query
				};
			});

			items.push({
				icon: 'save',
				text: this.ii('SAVE')
			});

			return items;
		}
	},
	watch: {
		$route() {
			this.$refs.dropPanel.close();
		}
	},
	methods: {
		remove(item) {
			let params = {};
			params[item.key] = undefined;
			this.editQueryParams(params);
		},
		getFormattedOwnership() {
			switch (this.app.query.ownership) {
				case undefined: return this.ii('OWN');
				case 'granted': return this.ii('GRANTED');
				case 'all': return this.ii('ALL');
			}
			return this.app.query.ownership;
		},
		getFormattedVal(key) {
			let val = this.app.query[key];
			let filter = this.filtersMap[key];
			if (!filter) return val;

			let prefix = '';
			if (filter.type === 'multisel') {
				if (val.indexOf('n_') === 0) {
					val = val.slice(2);
					prefix = this.ii('NOT') + ' ';
				}
				val = val.split(',').map(it => {
					if (key === 'geo') return this.getCountryByCode(it);
					if (key === 'lang') return this.getLanguageByCode(it);
					return it;
				}).join(', ');
			} else if (filter.type === 'lists') {
				let lists = {white: [], black: []};
				val.split('|').forEach(part => {
					let key = 'white';
					if (part.indexOf('n_') === 0) {
						key = 'black';
						part = part.slice(2);
					}
					part.split(',').forEach(it => {
						if (it) {
							lists[key].push(it);
						}
					});
				});
				let parts = [];
				if (lists.white.length) {
					parts.push(lists.white.join(', '));
				}
				if (lists.black.length) {
					parts.push(this.ii('NOT') + ' ' + lists.black.join(', '));
				}
				val = parts.join(' ');
			}

			return prefix + val;
		},
		addFilter(filter) {
			this.newFilterKey = filter.key;
		},
		onAddFilterChange(active) {
			if (!active) {
				this.newFilterKey = null;
			}
		},
		onOwnershipChange() {
			this.refreshQuery();
			let panel = this.$refs.filterPanel_ownership;
			panel && panel.close && panel.close();
		},
		onFilterChange(itemKey) {
			let panel = this.$refs['filterPanel_' + itemKey][0];
			panel && panel.close && panel.close();
		},
		handleSegmentError(err) {
			let msg;
			switch (err.message) {
				case 'NAME_EMPTY':
					msg = 'SEGMENT_NAME_CANNOT_BE_EMPTY';
					break;
				case 'SEGMENT_EXISTS':
					msg = 'SEGMENT_WITH_SUCH_NAME_EXISTS_ALREADY';
					break;
			}
			this.alert(this.ii(msg));
		},
		onSegmentClick(item) {
			this.$refs.segmentsDropPanel.close();
		},
		async addSegment() {
			let name = await this.prompt(this.ii('ENTER_SEGMENT_NAME'));
			if (name === null) return;
			if (!name) return this.alert(this.ii('SEGMENT_NAME_CANNOT_BE_EMPTY'));

			let query = location.search.replace(/^\?/, '');
			try {
				await this.http.post('Auth.addSegment', name, query)
			} catch (err) {
				return this.handleSegmentError(err);
			}

			this.$refs.segmentsDropPanel.close();
			this.app.loadSegments();
		},
		async editSegment(item) {
			let name = await this.prompt(this.ii('ENTER_SEGMENT_NEW_NAME'), item.text);
			if (name === null) return;
			if (!name) return this.alert(this.ii('SEGMENT_NAME_CANNOT_BE_EMPTY'));

			try {
				await this.http.post('Auth.editSegment', item.id, name);
			} catch (err) {
				return this.handleSegmentError(err);
			}

			this.app.loadSegments();
		},
		async removeSegment(item) {
			let ok = await this.confirm(this.iiArgs('REMOVE_SEGMENT_N_QST', item.text));
			if (!ok) return;

			await this.http.post('Auth.removeSegment', item.id);
			this.app.loadSegments();
		}
	}
}